import { apiPost } from '@/app/Dataman';
import { INGREDIENTS_EXTRACTOR_PATHS } from './paths';

export default {
  postIngredientsProcess: (params, file) => {
    const options = { params };

    if (file) {
      const data = new FormData();
      data.append('image_file', file);
      options.data = data;
      options.headers = { 'content-type': 'multipart/form-data' };
    }

    return apiPost(`${INGREDIENTS_EXTRACTOR_PATHS.ingredientsProcess}`, options);
  },
};
